import { render, staticRenderFns } from "./CHelpWidget.vue?vue&type=template&id=0dccdd27&scoped=true&"
import script from "./CHelpWidget.vue?vue&type=script&lang=ts&"
export * from "./CHelpWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CHelpWidget.vue?vue&type=style&index=0&id=0dccdd27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dccdd27",
  null
  
)

export default component.exports